// AWS Cognito Configuration
// Using public SPA client - no client secret, no SECRET_HASH required
export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_XIYUyyrnD',
      userPoolClientId: 'tqa4mjsemva5m78vu7rtihnnh', // New public SPA client
      // SRP authentication flow enabled
    }
  }
};

